import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';
import { swiperOnResize } from '../utils/swiperOnResize.utils.js';

let popularSwiperWr = document.querySelectorAll('.popular-swiper-wr');
popularSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    if (el.classList.contains('grid-type')) {
      swiperOnResize('(max-width: 1023px)', swiperEl, {
        modules: [Autoplay, Navigation],
        spaceBetween: 16,
        slidesPerView: 1,
        threshold: 10,
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        breakpoints: {
          440: {
            slidesPerView: 1.5,
          },
          640: {
            spaceBetween: 16,
            slidesPerView: 2,
          },
          768: {
            spaceBetween: 20,
            slidesPerView: 2.5,
          },
          1024: {
            spaceBetween: 16,
            slidesPerView: 3,
          },
          1200: {
            spaceBetween: 20,
            slidesPerView: 3,
          },
        },
      });
    } else {
      let swiper = new Swiper(swiperEl, {
        modules: [Autoplay, Navigation],
        observer: true,
        observeParents: true,
        spaceBetween: 16,
        slidesPerView: 1,
        threshold: 10,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        breakpoints: {
          440: {
            slidesPerView: 1.5,
          },
          640: {
            spaceBetween: 16,
            slidesPerView: 2,
          },
          768: {
            spaceBetween: 20,
            slidesPerView: 2.5,
          },
          1024: {
            spaceBetween: 16,
            slidesPerView: 3,
          },
          1200: {
            spaceBetween: 21,
            slidesPerView: 3,
          },
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
      });

      let previousThirdItem = null;

      function updateShadows() {
        const slides = swiper.slides;
        const activeIndex = swiper.activeIndex;
        const thirdItemIndex = activeIndex + 3;

        if (window.innerWidth > 1201) {
          if (previousThirdItem) {
            previousThirdItem.style.boxShadow = "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px";
          }

          if (slides[thirdItemIndex]) {
            slides[thirdItemIndex].style.boxShadow = "none";
            previousThirdItem = slides[thirdItemIndex];
          } else {
            previousThirdItem = null;
          }
        }
      }

      swiper.on("slideChange", updateShadows);

      updateShadows();


      swiperObserver(swiper);
    }
  }
});
